export default __webpack_public_path__ + "static/media/enjoyCard2.0e6a1eeb.webp";